import { useState } from "react";
import { Button, Col, Form, Input, Row, Select, Spin } from "antd";

import AppCard from "../../components/AppCard";

const UpdateOrgan = () => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const onFinish = (value) => {
    setLoading(false)
    console.log(value);
  };

  return (
    <Spin spinning={loading}>
      <AppCard heading="Edit Organ">
        <Form onFinish={onFinish} form={form} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <Form.Item name="system" label="Select System" rules={[{ required: true, message: "Please enter system name" }]}>
                <Select />
                <Select.Option></Select.Option>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name="organ" label="Enter Organ Name" rules={[{ required: true, message: "Please enter system name" }]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <div className="center">
            <Button type="primary" htmlType="submit">
              Update Organ
            </Button>
          </div>
        </Form>
      </AppCard>
    </Spin>
  );
};

export default UpdateOrgan;
